module.exports = __webpack_public_path__ + "img/slider_header.b69c861a.jpg";